export default{

    setBetState : (state, data) => {
        state.chosenBets.push(data)
    }
}